import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_878xd92w4w: FaireBrandEntity = {
  token: "b_878xd92w4w",
  type: "brand",
  name: "Bits & Bows",
  avatarUrl:
    "https://cdn.faire.com/fastly/f7ed076fd599b020d5670e3beac05836635a85a7ef2fd4fa95ecc10338f5fa0a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b341f55cad55d848da622b2a62dc61768ace7b5b4bad0e418d969482b450c4fd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f7ed076fd599b020d5670e3beac05836635a85a7ef2fd4fa95ecc10338f5fa0a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b341f55cad55d848da622b2a62dc61768ace7b5b4bad0e418d969482b450c4fd.jpeg",
  location: "PA, USA",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 20,
  isTopShop: true,
  isInsider: true,
  description:
    "Bits & Bows is a sister-founded brand dedicated to cultivating more magic in the everyday and instilling more joy into every outfit decision. Our Bow Baseball Hats™ and Baseball Hats add a fun, finishing touch to a sportswear staple.  From play dates to pool days to the bleachers to the beach, from the court to the green -- and everywhere in between -- no matter the occasion, we have the perfect piece of polished playwear™ to complete any look with our delightfully diverse collection of purposefully-designed, premium quality headwear and other celebratory accessories and apparel.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:56.541Z",
    importedBy: "entity-db-cli",
  },
};
